<template>
	<transition
		enter-active-class="transition-all duration-3s timing-ease"
		leave-active-class="transition-all duration-3s timing-ease"
		enter-class="opacity-0"
		enter-to-class="opacity-1"
		leave-class="opacity-1"
		leave-to-class="opacity-0"
		@after-enter="showContent = true"
		@before-leave="showContent = false"
	>
		<div
			class="fixed inset-0"
			style="background-color:rgba(255,255,255,.5); z-index:99999;"
			@click.self="toggleMiniBasket"
			v-if="isVisible"
		>
			<transition
				enter-active-class="transition-transform duration-3s timing-ease"
				leave-active-class="transition-transform duration-3s timing-ease"
				enter-class="translate-x-100"
				enter-to-class="translate-x-0"
				leave-class="translate-x-0"
				leave-to-class="translate-x-100"
			>
				<div
					class="absolute inset-y-0 right-0 max-w-full text-black pl-6"
					v-if="showContent"
					style="width:500px;"
				>
					<div
						class="absolute inset-0 bg-white shadow-lg p-6 flex flex-col"
					>
						<header
							class="flex text-base sm:text-2xl pt-2 mt-0 sm:pb-6 border-0 border-b border-gray-200 bg-transparent text-black justify-start items-center"
						>
							<span class="mr-4">Kurv</span>
							<div
								class="bg-gray-50 text-black text-xs py-1 px-2 rounded-sm mr-auto"
								v-if="basket.Now && basket.Expires"
							>
								Udløber om
								<Countdown
									class="font-bold text-top"
									:now="basket.LocalNow"
									:expires="basket.LocalExpires"
								/>
							</div>
							<button
								class="bg-transparent border-0 p-2 h-8"
								@click="toggleMiniBasket"
							>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									fill="none"
									viewBox="0 0 12 12"
									class="w-3"
								>
									<path
										fill="#000"
										fill-rule="evenodd"
										d="M6 7l-4 5-2-2 5-4-5-4 2-2 4 5 4-5 2 2-5 4 5 4-2 2-4-5z"
										clip-rule="evenodd"
									/>
								</svg>
							</button>
						</header>

						<template v-if="basket.OrderLines && basket.OrderLines.length == 0">
							<div class="my-auto text-center">
								<div class="font-bold text-base">Din kurv er tom</div>
							</div>
						</template>

						<template v-else class="text-xs">
							<div class="overflow-y-auto -mx-6 px-6">
								<div
									class="flex py-3 sm:py-5"
									v-for="ol in basket.OrderLines"
									:key="ol.ProductId"
								>
									<div class="mr-auto">
										<div class="font-bold">{{ ol.ProductName }}</div>
										<div>
											<add-to-basket-button
												:product-id="ol.ProductId"
												:sold-out="false"
												:waiting-list-allowed="false"
												:max-for-sale="ol.MaxForSale"
											></add-to-basket-button>
										</div>
										<div
											class="text-xs text-gray-500 cursor-pointer"
											@click="removeFromCart(ol.ProductId)"
										>
											Fjern
										</div>
									</div>
									<div class="text-right">{{ ol.Total | toCurrency }}</div>
								</div>
							</div>

							<div
								class="border-t border-b border-gray-300 py-3 sm:py-5 flex mt-auto"
							>
								<div class="mr-auto">Subtotal</div>
								<div class="text-right">
									{{ basket.TotalPrice | toCurrency }}
								</div>
							</div>

							<div v-if="basket.OrderLines && basket.OrderLines.length > 0">
								<div
									v-if="basket.MemberCheckoutAllowed"
									class="rounded-sm bg-teal-100 mt-4 sm:mt-6 p-3 sm:p-5 text-center"
									style="background-color:#d4f2f4"
								>
									<div class="text-tinier leading-tight sm:text-xs">
										<b>Har du personligt sæson/turkort?</b><br />Kom hurtigt i
										mål med din bestilling.
									</div>
									<div class="mt-3">
										<button
											@click="checkoutAsMember"
											class="rounded-sm bg-teal-600 text-white px-6 py-2 font-bold"
											style="background-color:#56B8BE"
										>
											Bestil med sæson/turkort
										</button>
									</div>
								</div>

								<div
									v-if="basket.MobilePayCheckoutAllowed && allowMobilepay && mobilpaycheckoutenabled"
									class="rounded-sm bg-blue-100 mt-4 sm:mt-6 p-3 sm:p-5 text-center"
									style="background-color:#EAEDFB"
								>
									<div class="text-tinier leading-tight sm:text-xs">
										<b>Spar tid!</b><br />Tilmelder du kun dig selv?
									</div>
									<div class="mt-3">
										<button
											@click="checkoutWithMobilePay"
											class="rounded-sm bg-blue-600 text-white px-6 pt-2 pb-1 font-bold"
											style="background-color:#5A78FF"
										>
											<svg
												xmlns="http://www.w3.org/2000/svg"
												fill="none"
												viewBox="0 0 173 22"
												class="h-5 max-w-full"
											>
												<path
													fill="#fff"
													fill-rule="evenodd"
													d="M26.2 16h1.7c.1 0 .2 0 .3-.2l2-6.3h.2l2.3 6.2c0 .2.2.3.3.3h1.1c.2 0 .3 0 .3-.3l2.3-6.2h.2l2 6.3c0 .1 0 .2.2.2H41c.2 0 .3-.1.3-.3l-3-9.7-.3-.2h-1.5c-.2 0-.3.1-.3.2l-2.4 6.1c0 .2-.2.1-.2 0l-2.4-6c0-.2-.1-.3-.3-.3h-1.5L29 6l-3 9.7c0 .2 0 .3.2.3zm19.5.2a4 4 0 01-4-4 4 4 0 014-4c2.3 0 4 1.8 4 4a4 4 0 01-4 4zm0-1.9c1 0 2-1 2-2a2 2 0 00-2-2.2c-1.1 0-2 1-2 2.1 0 1.2.9 2.1 2 2.1zm9.6 1.9a3 3 0 01-2-.8c-.1-.1-.3 0-.3.1v.2c0 .2-.1.3-.3.3h-1.4a.3.3 0 01-.2-.3V6.1c0-.2 0-.3.2-.3h1.5c.2 0 .3.1.3.3v2.7c0 .2.1.3.3.1.5-.3 1.1-.6 2-.6 2 0 3.6 1.7 3.6 4 0 2.2-1.6 3.9-3.7 3.9zm-.3-1.9c1.1 0 2-1 2-2a2 2 0 00-2-2.2c-1 0-2 1-2 2.1 0 1.2.9 2.1 2 2.1zm6.4-6.7c.6 0 1.2-.5 1.2-1.1 0-.6-.6-1.1-1.2-1.1s-1.1.5-1.1 1.1c0 .6.5 1.1 1.1 1.1zm-.7 8.4H62c.2 0 .3-.1.3-.3v-7c0-.1-.1-.2-.3-.2h-1.4c-.2 0-.3.1-.3.3v7s.1.2.3.2zm6.1 0c.2 0 .3 0 .3-.2v-1.2c0-.2-.1-.3-.3-.3-.5 0-.7-.3-.7-.8V6c0-.2-.1-.3-.3-.3h-1.5c-.1 0-.2.1-.2.3v7.3c0 2 .8 2.7 2.7 2.7zm4.8.2a3.8 3.8 0 01-4-4c0-2.2 1.8-4 4-4s3.9 1.8 3.9 4.1c0 .3-.1.5-.4.5H70c-.2 0-.2 0-.2.2.1.8.9 1.5 1.8 1.5.7 0 1.1-.3 1.5-.7.1-.2.3-.2.4-.2H75c.3 0 .4.2.3.4-.5 1.3-2 2.2-3.6 2.2zM70 11.6H73c.2 0 .2 0 .2-.2-.2-.8-.9-1.4-1.7-1.4-.9 0-1.5.6-1.7 1.4v.2zm7.2 4.4c-.1 0-.2-.1-.2-.3V6.1c0-.2 0-.3.2-.3H82c2.1 0 3.6 1.3 3.6 3.4 0 2-1.7 3.4-3.8 3.4h-2.5c-.1 0-.2.1-.2.3v2.8c0 .2-.2.3-.3.3h-1.6zm2.1-5.1h2.5c1 0 1.7-1 1.7-1.7 0-.8-.6-1.6-1.7-1.6h-2.5c-.2 0-.2 0-.2.3v2.7c0 .2 0 .3.2.3zm10.5 5.3c-2 0-3.7-1.7-3.7-4 0-2.2 1.7-4 3.7-4a3 3 0 012 .8c.1.2.3.1.3 0v-.3c0-.1.1-.2.3-.2h1.4c.1 0 .3.1.3.3v5c0 .3 0 .5.3.5.2 0 .3 0 .3.2v1.3c0 .2-.1.3-.3.3-1 0-1.5-.3-1.9-.9 0-.1-.2-.2-.3 0-.6.5-1.3 1-2.4 1zm.3-1.9c1.1 0 2-.9 2-2 0-1.3-.9-2.2-2-2.2-1 0-2 1-2 2.1 0 1.2 1 2.1 2 2.1zm5.6 4.6c2.2 0 3.3-.9 4.3-3.3l2.8-6.8c.1-.2 0-.3-.2-.3h-1.4c-.2 0-.3 0-.3.2l-1.7 4c-.1.3-.3.3-.4 0l-1.8-4c0-.1-.1-.2-.3-.2h-1.4c-.2 0-.4.1-.3.4l2.8 6.2v.6c-.2 1-1.1 1.5-2.1 1.5-.2 0-.3 0-.3.2v1.2c0 .2.1.3.3.3zm16.1-2.8c2 0 3.7-1 4.6-2.4.2-.4 0-.6-.2-.6h-.6c-.3 0-.3.1-.5.3a4 4 0 01-7.3-2.5 4 4 0 014-4.2c1.4 0 2.6.7 3.3 1.6.1.2.2.3.5.3h.6c.3 0 .3-.3.2-.5a5.2 5.2 0 00-4.6-2.5c-2.9 0-5.3 2.4-5.3 5.3 0 3 2.3 5.2 5.3 5.2zm6.5-.1h.6c.2 0 .3-.1.3-.3v-4c0-1.1 1-2.2 2.2-2.2 1.3 0 2 1 2 2.2v4c0 .2.2.3.4.3h.5c.2 0 .3-.1.3-.3v-4.1c0-1.8-1.2-3.1-3-3.1-1 0-1.6.4-2 .8-.2 0-.4 0-.4-.2v-3c0-.2-.1-.3-.3-.3h-.6c-.1 0-.2.1-.2.3v9.6c0 .2 0 .3.2.3zm11.8.1c-2.3 0-3.8-1.5-3.8-3.8s1.6-3.8 3.8-3.8c2.1 0 3.7 1.6 3.7 3.9 0 .2 0 .3-.3.3h-5.9l-.1.2c.2 1.4 1.2 2.2 2.6 2.2.9 0 1.6-.3 2.1-.9l.5-.2h.6c.2 0 .3.2.2.4A4 4 0 01130 16zm-2.5-4.3h4.8c.1 0 .2 0 .2-.2-.3-1.2-1.3-2-2.5-2-1.3 0-2.3.8-2.6 2l.1.2zM139 16c1.6 0 3-.7 3.5-2 .1-.2 0-.3-.2-.3h-.6l-.4.2c-.5.8-1.3 1.1-2.3 1.1a2.7 2.7 0 01-2.7-2.8c0-1.5 1.2-2.8 2.7-2.8 1 0 1.7.4 2.2 1 .1.2.2.3.4.3h.6c.2 0 .3-.2.2-.4-.7-1.3-1.8-2-3.4-2a3.8 3.8 0 00-3.8 4c0 2 1.7 3.7 3.8 3.7zm11 0c.3 0 .4-.1.4-.3v-.4c0-.2-.1-.3-.3-.3-.8 0-1.3-.8-2.2-2.2l-.7-1c-.2-.3 0-.5.2-.7l2.3-2.1c.2-.2 0-.5-.2-.5h-.6l-.3.1-3 2.8c-.2.2-.4.2-.4 0V6c0-.2-.1-.3-.3-.3h-.5c-.2 0-.3.1-.3.3v9.6c0 .2.1.3.3.3h.5c.2 0 .3-.1.3-.3v-2.4l.1-.2.6-.5c.2-.2.3-.2.5 0l.6 1c1.3 2 1.8 2.5 3 2.5zm4.5 0a3.8 3.8 0 01-3.8-3.8c0-2.2 1.7-3.8 3.8-3.8 2.2 0 3.9 1.7 3.9 3.8 0 2.2-1.7 3.8-3.9 3.8zm0-1c1.5 0 2.7-1.2 2.7-2.8 0-1.5-1.2-2.8-2.7-2.8a2.7 2.7 0 00-2.7 2.8c0 1.6 1.2 2.8 2.7 2.8zm8.6 1c1 0 1.7-.4 2.2-.9.2-.2.3-.1.4.1.2.5.7.8 1.4.8l.2-.2v-.7l-.2-.2c-.3 0-.4-.2-.4-.6V9l-.3-.3h-.6l-.3.3v4c0 1.2-1 2.2-2.2 2.2-1.3 0-2.1-1-2.1-2.2V9c0-.1-.1-.3-.3-.3h-.6l-.3.3V13c0 1.8 1.3 3.1 3 3.1zm9 0c.2 0 .3-.1.3-.3v-.6l-.2-.2c-1.1 0-1.9-.4-1.9-1.8V9.9l.3-.3h1.4c.2 0 .3 0 .3-.2v-.5c0-.1-.1-.3-.3-.3h-1.4a.3.3 0 01-.3-.3V7c0-.1 0-.3-.2-.3h-.6c-.2 0-.3.2-.3.3v1.3c0 .2-.1.3-.3.3h-.7c-.2 0-.3.2-.3.3v.5c0 .1.1.2.3.2h.7c.2 0 .3.2.3.3v3.3c0 2 1 2.9 2.8 2.9z"
													clip-rule="evenodd"
												/>
												<path
													fill="#fff"
													d="M9.8 14.4a16 16 0 014.5-.8c2 0 3.7.4 5.1 1.2V9a10.3 10.3 0 00-9.6 0v5.4z"
												/>
												<path
													fill="#fff"
													d="M7 8l2.2 5.2v-5c1.1-.6 2.3-1 3.6-1.1 1.3-.2 2.7-.2 4.4 0L16 4.4c-1.7 0-3.4.2-5 .9-1.5.6-2.8 1.6-4 2.8z"
												/>
												<path
													fill="#fff"
													d="M11.3 4.4l-.9-2.1C10 1.3 9 .8 8 1.3L2 3.6C1 4 .6 5.2 1 6.2L6.7 20c.4 1 1.5 1.5 2.5 1l6-2.4c.9-.4 1.3-1.5 1-2.5l-.8-1.7a23.7 23.7 0 00-1.3 0l.9 2.2c.1.3 0 .7-.4.9l-5.9 2.4c-.3.1-.7 0-.8-.4L2.2 5.7c-.2-.3 0-.7.3-.8l6-2.5c.3-.1.6 0 .8.4l.8 2a10 10 0 011.2-.4z"
												/>
											</svg>
										</button>
									</div>
								</div>

								<div
									v-if="basket.MemberCheckoutAllowed"
									class="items-center mt-6 hidden sm:flex"
								>
									<hr class="border-t border-gray-500 flex-grow" />
									<div class="mx-2">eller</div>
									<hr class="border-t border-gray-500 flex-grow" />
								</div>

								<div class="flex mt-4 sm:mt-6">
									<button
										@click="toggleMiniBasket"
										class="bg-white border-gray-400 border rounded-sm text-black px-10 py-4 mr-4 font-bold"
									>
										Køb mere
									</button>
									<button
										@click="checkout"
										class="bg-top rounded-sm text-top-text px-6 py-4 font-bold flex-grow"
									>
										Gå til kassen
									</button>
								</div>
							</div>
						</template>
					</div>
				</div>
			</transition>
		</div>
	</transition>
</template>

<script>
import store from "./store";
import AddToBasketButton from "./AddToBasketButton";
import Countdown from "./Countdown";

export default {
	data() {
		return {
			showContent: false,
			mobilpaycheckoutenabled: false
		};
	},
	props: {
		allowMobilepay: Boolean
	},
	components: { AddToBasketButton, Countdown },
	computed: {
		basket: function() {
			return this.$store.getters.basket;
		},
		isVisible: function() {
			return this.$store.getters.miniBasketVisible;
		}
	},
	methods: {
		toggleMiniBasket: function() {
			this.$store.dispatch("toggleMiniBasket");
		},
		checkout: function() {
			this.$store.dispatch("toggleCheckout", "");
		},
		checkoutAsMember: function() {
			this.$store.dispatch("toggleCheckout", "member");
		},
		checkoutWithMobilePay: function() {
			this.$store.dispatch("toggleCheckout", "mobilePay");
		},
		removeFromCart: function(productId) {
			this.$store.dispatch("updateBasketQuantity", {
				productId: productId,
				quantity: 0
			});
		}
	}
};
</script>
